import type React from 'react'
import { Divider } from '../divider'

type GroupProps = {
  children: React.ReactNode
  title?: string
}

export function Group({ children, title }: GroupProps) {
  const hasTitle = !!title?.length

  return (
    <div className="flex flex-col">
      <Divider />
      <div className="px-fivepulse py-twopulse">
        {hasTitle && (
          <h2 className="font-bold text-rdmodern text-text-neutral-readonly text-threeandhalfpulse leading-small">
            {title}
          </h2>
        )}
      </div>
      {children}
    </div>
  )
}
